import { useState, useEffect, useCallback } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getSalesTeamsUsers } from '../api'

export const useGetSalesTeamUsersMultiple = (ids?: number[]) => {
  const dispatch = useAppDispatch()

  const [teamIds, setTeamIds] = useState(ids)
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  const execute = useCallback((ids: number[]) => setTeamIds(ids), [])

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        if (!!teamIds && teamIds.length > 0) {
          setStatus('pending')
          const result = await dispatch(getSalesTeamsUsers(teamIds))

          if (mounted) {
            if (getSalesTeamsUsers.fulfilled.match(result)) {
              setStatus('success')
            } else {
              setStatus('fail')
            }
          }
        }
      } catch (error) {
        if (mounted) setStatus('fail')
      } finally {
        if (mounted) {
          setStatus('idle')
          setTeamIds(undefined)
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, teamIds])

  return { status, execute }
}
